import { z } from "zod"
import { PartGrade } from "./part-grade"

export const PartGradeDescriptionsSchema = z.record(
  z.nativeEnum(PartGrade),
  z.string(),
)

export type PartGradeDescriptions = z.infer<typeof PartGradeDescriptionsSchema>
